import { ResponsiveLine } from '@nivo/line';
import React from 'react';

const Line = (props) => {
  return <ResponsiveLine {...props} />;
};

export default Line;
